import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';

export interface DragHandleProps {
  ref: (node: HTMLElement | null) => void;
  attributes: DraggableAttributes;
  listeners: DraggableSyntheticListeners;
}

interface Props {
  id: string;
  children: (dragHandleProps: DragHandleProps) => ReactNode;
}

export default function SortableBlock({ id, children }: Props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative' as const,
  };

  const dragHandleProps: DragHandleProps = {
    ref: setActivatorNodeRef,
    attributes,
    listeners,
  };

  return (
    <Box ref={setNodeRef} style={style}>
      {children(dragHandleProps)}
    </Box>
  );
}
